/** 鉄骨造の判定閾値 隣接建築物用 */
export const THRESHOLD_NEIGHBORING_STEEL = {
  /* 危険(Cランク) Bランクの上限超過 */
  THRESHOLD_RANK_B: 4
} as const

/** 鉄筋造の判定閾値 隣接建築物用 */
export const THRESHOLD_NEIGHBORING_REINFORCED = {
  /* 危険(Cランク) Bランクの上限超過 */
  THRESHOLD_RANK_B: 2
} as const
